import { render, staticRenderFns } from "./Birds.vue?vue&type=template&id=51d167b6&scoped=true"
import script from "./Birds.vue?vue&type=script&lang=js"
export * from "./Birds.vue?vue&type=script&lang=js"
import style0 from "./Birds.vue?vue&type=style&index=0&id=51d167b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d167b6",
  null
  
)

export default component.exports